import { Link } from "react-router-dom";

const Footer = () => (
  <footer
    data-testid="footer"
    className="relative overflow-hidden border-t border-[#27272A] bg-[#050505]"
  >
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8">
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="block h-3 w-3 bg-[#CC0A14]" />
            <span className="font-syne text-lg font-extrabold tracking-[0.18em] text-white">
              BP<span className="text-[#CC0A14]">//</span>CLUB
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
            A UK club for men sharpening the jaw and deleting processed food.
            Built on discipline, not products.
          </p>
        </div>
        <div>
          <p className="font-jb text-[11px] uppercase tracking-[0.25em] text-zinc-600">Navigate</p>
          <div className="mt-4 flex flex-col gap-3">
            <Link
              data-testid="footer-link-method"
              to="/method"
              className="text-sm text-zinc-400 transition-colors duration-300 hover:text-[#CC0A14]"
            >
              The Method
            </Link>
            <Link
              data-testid="footer-link-journal"
              to="/journal"
              className="text-sm text-zinc-400 transition-colors duration-300 hover:text-[#CC0A14]"
            >
              The Journal
            </Link>
            <Link
              data-testid="footer-link-home"
              to="/"
              className="text-sm text-zinc-400 transition-colors duration-300 hover:text-[#CC0A14]"
            >
              Home
            </Link>
          </div>
        </div>
        <div>
          <p className="font-jb text-[11px] uppercase tracking-[0.25em] text-zinc-600">The Club</p>
          <p className="mt-4 text-sm leading-relaxed text-zinc-500">
            bpclub.uk — United Kingdom
            <br />
            Not medical advice. Train smart,
            <br />
            get professional clearance if needed.
          </p>
        </div>
      </div>
    </div>

    <div className="pointer-events-none select-none px-2" aria-hidden="true">
      <p className="text-outline whitespace-nowrap text-center font-syne text-[19vw] font-extrabold leading-[0.85] tracking-tight">
        BP CLUB
      </p>
    </div>

    <div className="border-t border-[#1a1a1d]">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-5 py-5 sm:px-8">
        <p className="font-jb text-[10px] uppercase tracking-[0.2em] text-zinc-600">
          © 2026 BP Club — bpclub.uk
        </p>
        <p className="font-jb text-[10px] uppercase tracking-[0.2em] text-zinc-600">
          Sharpen the jaw <span className="text-[#CC0A14]">◆</span> Eat real food
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
